export default __webpack_public_path__ + "static/media/odinsOperations.042a129b.png";